import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import GLightbox from 'glightbox';
import Pristine from 'pristinejs';


window.addEventListener('load', () => {


  // transition fix
  document.body.classList.add('loaded');


});

document.addEventListener('DOMContentLoaded', function () {


  // toggle
  const toggle = (toggleLinksSelector, togglePanelsSelector, allowCloseAlreadyOpened, allowScrollTo, allowScrollToPosition, allowIndividualCloseOpen) => {
    const toggleLinks = document.querySelectorAll(toggleLinksSelector);
    const togglePanels = document.querySelectorAll(togglePanelsSelector);

    const handleLinkClick = function (e) {
      const link = this;
      const panelId = link.getAttribute('aria-controls');
      const isAlreadyActive = link.classList.contains('active');
      const toggleActivePanel = document.getElementById(panelId);

      if (!allowCloseAlreadyOpened && isAlreadyActive) {
        e.preventDefault();
        return;
      }

      const shouldOpen = !isAlreadyActive;

      if (!allowIndividualCloseOpen && shouldOpen) {
        toggleLinks.forEach(btn => {
          if (btn.getAttribute('aria-controls') !== panelId) {
            btn.classList.remove('active');
            btn.setAttribute('aria-expanded', 'false');
          }
        });

        togglePanels.forEach(panel => {
          if (panel.id !== panelId) {
            panel.classList.remove('open');
            panel.classList.remove('transitionend');
            if (panel._scrollHandler) {
              panel.removeEventListener('transitionend', panel._scrollHandler);
              delete panel._scrollHandler;
            }
          }
        });
      }

      toggleLinks.forEach(btn => {
        if (btn.getAttribute('aria-controls') === panelId) {
          if (shouldOpen) {
            btn.classList.add('active');
            btn.setAttribute('aria-expanded', 'true');
          } else {
            btn.classList.remove('active');
            btn.setAttribute('aria-expanded', 'false');
          }
        }
      });

      if (toggleActivePanel) {
        if (shouldOpen) {
          toggleActivePanel.classList.remove('transitionend');
          toggleActivePanel.offsetHeight; // trigger reflow
          toggleActivePanel.classList.add('open');

          const onTransitionEnd = (event) => {
            if (event.target !== toggleActivePanel) return;
            toggleActivePanel.classList.add('transitionend');

            if (allowScrollTo) {
              link.scrollIntoView({
                behavior: 'smooth',
                block: allowScrollToPosition
              });
            }

            toggleActivePanel.removeEventListener('transitionend', onTransitionEnd);
            delete toggleActivePanel._scrollHandler;
          };

          toggleActivePanel._scrollHandler = onTransitionEnd;
          toggleActivePanel.addEventListener('transitionend', onTransitionEnd);
        } else {
          toggleActivePanel.classList.remove('open');
          toggleActivePanel.classList.remove('transitionend');

          if (toggleActivePanel._scrollHandler) {
            toggleActivePanel.removeEventListener('transitionend', toggleActivePanel._scrollHandler);
            delete toggleActivePanel._scrollHandler;
          }
        }
      }

      e.preventDefault();
    };

    document.addEventListener('click', function (e) {
      if (e.target.matches(toggleLinksSelector) || e.target.closest(toggleLinksSelector)) {
        const link = e.target.matches(toggleLinksSelector) ? e.target : e.target.closest(toggleLinksSelector);
        handleLinkClick.call(link, e);
      }
    });
  };

  toggle('.js-site-principes-links', '.js-site-principes-panels', true, false, '', true);
  toggle('.js-site-features-links', '.js-site-features-panels', false, false, '', false);
  toggle('.js-form-wrap-links', '.js-form-wrap-panels', false, false, '', false);


  // Links that jump to a form section and should open a specific panel on
  // arrival (the pagalba hero buttons: "Užsisakyti pavyzdį" / "Kviesti į
  // namus"). Reuses the toggle above by clicking its own tab button, so the
  // open/close behaviour stays in one place. Without JS the link still scrolls
  // to the form — only the preselected tab is lost.
  document.querySelectorAll('[data-form-panel]').forEach(function (link) {
    link.addEventListener('click', function () {
      const header = document.getElementById(link.getAttribute('data-form-panel') + '-header');
      if (header && !header.classList.contains('active')) {
        header.click();
      }
    });
  });


  // form validation
  const formValidation = document.querySelectorAll(".js-form-validation");

  formValidation.forEach((form) => {
    const config = {
      classTo: 'js-form-validation-group',
      errorClass: 'form-regular__items--error',
      successClass: 'form-regular__items--success',
      errorTextClass: 'form-regular__error',
      errorTextTag: 'span',
      errorTextParent: 'js-form-validation-group'
    };

    // select the phone input specific to this loop iteration's form
    const phoneInput = form.querySelector('input[type="tel"]');

    // register the validator inside the loop so it has direct access to phoneInput
    Pristine.addValidator("phone-lt", function (value) {
      if (!value) return true;

      const ltPhoneRegex = /^(\+3706|06)\d{7}$/;
      return ltPhoneRegex.test(value.trim());
    }, function () {
      return phoneInput ? phoneInput.getAttribute("data-pristine-phone-lt-message") : "";
    }, 1, false);

    const pristine = new Pristine(form, config);

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const isValid = pristine.validate();

      if (isValid) {
        form.submit();
      }
    });
  });


  // slider
  var sliderBenefits = new Swiper('.js-slider-benefits', {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    grabCursor: true,
    navigation: {
      prevEl: '.js-slider-benefits-prev',
      nextEl: '.js-slider-benefits-next',
    },
    pagination: {
      clickable: true,
      dynamicBullets: true,
      el: '.js-slider-benefits-pagination',
    },
  });


  // gallery
  const lightbox = GLightbox({
    selector: '[data-gallery]'
  });


  // table responsive
  document.querySelectorAll('.body table:not([class])').forEach(function (table) {
    while (table.attributes.length > 0) {
      table.removeAttribute(table.attributes[0].name);
    }
    const wrapper = document.createElement('div');
    wrapper.classList.add('table-responsive');
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });


});